"use strict";

var createStorage = function (underlyingStorage) {

    return {
        get: function (key) {
            try {
                var rawValue = underlyingStorage.getItem(key);
                return rawValue ? JSON.parse(rawValue) : undefined;
            } catch (e) {
                return undefined;
            }
        },
        set: function (key, value) {
            try {
                underlyingStorage.setItem(key, JSON.stringify(value));
                return true;
            } catch (e) {
                return false;
            }
        },
        remove: function(key) {
            try {
                underlyingStorage.removeItem(key);
                return true;
            } catch (e) {
                return false;
            }
        },
        has: function(key){
            try {
                return underlyingStorage.getItem(key) !== null;
            } catch (e) {
                return false;
            }
        }
    };
};

module.exports = {
    session: createStorage(window.sessionStorage),
    local: createStorage(window.localStorage)
};
